module.exports = __webpack_public_path__ + "img/TBWTTNL_product_thumbnail.3fc3cfb5.png";